<template>
  <output :class="`spinner-border spinner-border-${size} text-${variant}`"></output>
</template>

<script setup lang="ts">
const VARIANTS = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
  "light",
  "dark"
] as const;

const SIZES = ["sm", "lg"] as const;

type Variant = typeof VARIANTS[number];
type Size = typeof SIZES[number];

const props = withDefaults(defineProps<{
  variant?: Variant;
  size?: Size;
}>(), {
  variant: "secondary",
  size: "sm"
});

if (!VARIANTS.includes(props.variant)) {
  console.warn(`Invalid variant "${props.variant}", allowed values are: ${VARIANTS.join(', ')}`);
}
if (!SIZES.includes(props.size)) {
  console.warn(`Invalid size "${props.size}", allowed values are: ${SIZES.join(', ')}`);
}
</script>
